<template>
    <div id="news-detail-page">
        <section class="news-detail-title section_gap append_gap">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 d_flex align-items-center">
                        <div class="about_content " style="width:100%">
                            <h2 class="title title_color">{{ title }}<br><small>{{ typeName }} | {{ publishTime }}</small> <br></h2>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <img v-if="mainImage" class="img-fluid" :src="mainImage" :alt=title>
                        <img v-else class="img-fluid" src="../assets/news/bed-bedroom-bedsheet-2387753.jpg" alt="img">
                    </div>
                </div>
            </div>
        </section>
        <div class="news-detail container">
            <div class="error" v-show="errorMessage">此頁面已不存在，請返回首頁</div>
            <div class="news-detail-content" v-html="content"></div>
            <div class="news-back-list" @click.stop="goNewsListPage()"><h3>↩ BACK</h3><small>回到最新消息列表</small></div>
            <div class="news-more">
              <h4>MORE</h4>
              <div class="row mb_30">
                  <div class="col-lg-4 col-md-6" v-for="(news, index) in newsMoreData" :key="index" @click.stop="goNewsDetailPage(news.news_id)">
                      <div class="single-recent-blog-post">
                          <div class="thumb">
                              <img v-if="news.main_img" class="img-fluid" :src="news.main_img" :alt=news.title>
                              <img v-else class="img-fluid" src="../assets/news/default-news-banner.jpg" alt="富杉晴最新消息">
                          </div>
                          <div class="details" :style="{'background': '#e6e6e6'}">
                              <div class="tags">
                                  <span class="tag_btn">{{news.type_name}}</span>
                              </div>
                              <h4 class="sec_h4 cursor_btn" @click.stop="goNewsDetailPage(news.news_id)">{{ news.title }}</h4>
                              <h6 class="date title_color">{{ news.publish_time }}</h6>
                          </div>	
                      </div>
                      
                   
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
// import newsData from '@/assets/news/news.json'
const pathheader = window.location.protocol
export default {
  name: 'NewsDetail',
  data () {
    return {
      id: '',
      newsData: [],
      errorMessage: false
    }
  },
  computed: {
    newsMoreData () {
      let more = []
      let length = this.newsData.length
      let iindex = this.newsData.findIndex(news => {
        return parseInt(news.news_id) === parseInt(this.id)
      })
      if (iindex === 0) {
        more = this.newsData.filter((n, index) => {
          return index > 0 && index < 4
        })
      } else if (iindex === length - 1) {
        more = this.newsData.filter((n, index) => {
          return (length - index > 0) && (length - index < 4)
        })
      } else if (iindex === 1) {
        more = this.newsData.filter((n, index) => {
          return (index === 0) || (index === iindex + 1) || (index === iindex + 2)
        })
      } else {
        more = this.newsData.filter((n, index) => {
          return (index === 0) || (index === iindex + 1) || (index === iindex - 1)
        })
      }
      return more
    },
    news () {
      // console.log(this.id)
      if (this.id === '') {
        this.errorMessage = true
        return {}
      }
      this.errorMessage = false
      return this.newsData.filter((news) => {
        // console.log(news.id, this.id)
        return (parseInt(news.news_id) === parseInt(this.id)) || (news.short_cut === this.id)
      })[0] || {}
    },
    title () {
      return this.news.title || ''
    },
    content () {
      return this.news.content || ''
    },
    publishTime () {
      return this.news.publish_time || ''
    },
    typeName () {
      return this.news.type_name || ''
    },
    mainImage () {
      return this.news.main_img || ''
    }
  },
  methods: {
    goNewsDetailPage (id) {
      this.$ga.event('news', 'news-detail-from-news-detail', id, 1)
      this.$router.push({name: 'NewsDetail', params: {id: id}})
    },
    goNewsListPage () {
      this.$ga.event('news', 'news-list-from-news-detail', this.id, 1)
      this.$router.push({name: 'News'})
    },
    getNews () {
      axios.get(pathheader + '//rich-sunshine.tw/backend/api/WebMain/getNews', {withCredentials: true})
      .then((response) => {
        // console.log(response)
        if (!response.data.success) {
          this.errorMessage = true
          this.newsData = []
          return
        }
        const res = response.data
        this.newsData = res.data
      })
      .catch((errorResponse) => {
        this.errorMessage = true
        // console.log(errorResponse)
      })
    }
  },
  mounted () {
    this.id = this.$route.params.id
    // console.log(this.id)
    this.getNews()
  }
}
</script>
<style lang="scss" scoped>
#news-detail-page {
    min-height: 100vh;
    .container {
      position: relative;
    }
    .news-detail {
      margin-top: 20px;
    }
    .news-detail-content {
      border: 1px solid #e6e6e6;
      padding: 100px 60px;
      text-align: left;
      margin-bottom: 100px;
      @media(max-width: 575px){
        padding: 30px 16px;
      }
    }
    .news-more {
      margin-bottom: 35px;
      padding-top: 11px;
      border-top: 1px solid #dfdfdf;
      & > h4 {
        color: #5b5b5b;
        font-weight: 700;
        font-size: 16px;
        letter-spacing: .1em;
        text-transform: uppercase;
        margin-bottom: 28px;
      }
    }
    .news-back-list {
      color: #5b5b5b;
      font-weight: 700;
      font-size: 16px;
      letter-spacing: .1em;
      text-transform: uppercase;
      margin-bottom: 28px;
      cursor:  pointer;
      :hover {
        color: #F3C300;
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/NewsDetail.vue